const pages = {
    home: {
        name: 'home',
        path: '/'
    },
    status: {
        root: 'status',
        statusComingSoon: {
            name: 'coming-soon',
            path: '/status/coming-soon'
        },
        statusMaintenance: {
            name: 'maintenance',
            path: '/status/maintenance'
        },
        status404: {
            name: '404',
            path: '/status/404'
        },
        status500: {
            name: '500',
            path: '/status/500'
        }
    },
    input: {
        name: 'input',
        path: '/sidebar/input'
    },
}

export default pages;